const checkDatePast = (date) => {
    const selectedDate = date ? new Date(date) : new Date();
    const currentDate = new Date();
    if (selectedDate < currentDate) {
        return true;
    } else {
        return false;
    }
}

export default checkDatePast;